// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import ImageSlider from "./components/ImageSlider";
import News from "./components/News";
import Time from "./components/Time";
import Footer from "./components/Footer";
import CallNumber from "./components/CallNumber";
import Team from "./pages/Team";
import Schedule from "./pages/Schedule";
import Education from "./pages/Education";
import Contact from "./pages/Contact";
import VisitProgress from "./pages/VisitProgress";
import AdminHome from "./pages/admin/AdminHome";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminSlotPage from "./pages/admin/AdminSlotPage";
import AdminNotice from "./pages/admin/AdminNotice";
import AdminSchedule from "./pages/admin/AdminSchedule";
import AdminTeam from "./pages/admin/AdminTeam";
import AdminSlider from "./pages/admin/AdminSlider";

export default function App() {
  return (
    <BrowserRouter>
      <Header />
      <main>
        <Routes>
          {/* 首頁 */}
          <Route
            path="/"
            element={
              <>
                <ImageSlider />
                <News />
                <Time />
                {/* <CallNumber id="3500" label="目前看診燈號" size="sm" />
                <CallNumber id="3501" label="目前看診燈號" size="sm" /> */}
              </>
            }
          />
          {/* 醫療團隊 */}
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/visitprogress" element={<VisitProgress />} />
          <Route path="/education" element={<Education />} />
          <Route path="/team" element={<Team />} />
          <Route path="/contact" element={<Contact />} />
          {/* admin路由… */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminHome />} />
            <Route path="notice" element={<AdminNotice />} />
            <Route path="schedule" element={<AdminSchedule />} />
            <Route path="slot" element={<AdminSlotPage />} />
            <Route path="team" element={<AdminTeam />} />
            <Route path="imageSlider" element={<AdminSlider />} />
          </Route>
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}
